import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { ContractorRelatedEntitiesAmountResponse } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  id: number;
  options?: Omit<
    UseQueryOptions<unknown, Error, ContractorRelatedEntitiesAmountResponse>,
    'queryKey' | 'queryFn'
  >;
}

export const useContractorRelatedEntitiesAmountRequest = ({ id, options }: RequestParams) => {
  const api = useApiInstance()

  return useQuery<unknown, Error, ContractorRelatedEntitiesAmountResponse>(
    [Entities.Contractors, id, 'amount-of-related-entities'],
    async () => {
      const { data } = await api.v1AdminContractorsContractorIdAmountRelatedEntitiesGet(id)
      return data as ContractorRelatedEntitiesAmountResponse
    },
    options,
  )
}
